
<Modal
  mayCancel="true"
  modalType="ImageLibrary"
  v-on:cancel="onCancel"
  class="m-auto-width"
  :anchorRect="anchorRect"
  anchorStyle="leftAuto"
>
  <ImageLibrary :onSelectImage="handleSelectImage"></ImageLibrary>
</Modal>
